import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=123ee59a&scoped=true&"
var script = {}
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=123ee59a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123ee59a",
  null
  
)

export default component.exports